import './bootstrap'
import { initStickyHeaders } from './custom/stickyHeader'
import './custom/main.js'
import './custom/date.js'
import './custom/program/show.js'
import './custom/notification.js'
import './custom/participant/assessment.js'
import './custom/participant/crud.js'
import './custom/custom.js'

initStickyHeaders()
